import { render, staticRenderFns } from "./WochenBrowser.vue?vue&type=template&id=8479039e&scoped=true&"
import script from "./WochenBrowser.vue?vue&type=script&lang=js&"
export * from "./WochenBrowser.vue?vue&type=script&lang=js&"
import style0 from "./WochenBrowser.vue?vue&type=style&index=0&id=8479039e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8479039e",
  null
  
)

export default component.exports